export default __webpack_public_path__ + "static/media/2img.babc42dd.png";